import { AppIntegrationsRepository } from 'common/repositories/index';

const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['$state', '$scope', 'Util'];

class ChooseDeviceOsDeploymentWizardController {

    constructor($state, $scope, Util) {

        this.$state = $state;
        this.$scope = $scope;
        this.Util = Util;

        $scope.imgPath = CWCONFIG.imgPath;

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        if (!this.app) {

            // app not found
            this.Util.closeModal();

        }
        this.supportedOs =
            AppIntegrationsRepository.getSupportedOs(this.app.id);

        // Product page with FSS banner allow users to download Phantom VPN only for mobile user
        // We filter the supportOs list for avpn0 only if deploy url is from product page
        if ($state.current.name.indexOf('root.dashboard.products') > -1 && this.$scope.inputData.appId === 'avpn0') {

            this.supportedOs = this.supportedOs.filter(os => os === 'android' || os === 'ios');

        }

        if (this.supportedOs && this.supportedOs.length === 1) {

            this.deployOn(this.supportedOs[0]);

        }

    }

    deployOn(os) {

        let stateName = this.$state.current.name;
        if (stateName.indexOf('.deploy') === -1) {

            stateName += '.deploy';

        }

        let params = {};

        if (this.$scope.inputData.deployType && os === 'windows' && this.$state.current.name.indexOf('root.dashboard.products') === -1) {

            params = angular.extend(params, {
                appId: this.$scope.inputData.appId,
                deployType: this.$scope.inputData.deployType,
                os,
            });

        } else {

            params = angular.extend(
                this.$state.params,
                {
                    resourceId: this.$scope.inputData.resourceId,
                    appId: this.app.id,
                    deviceId: 'new',
                    os,
                    licenseId: this.$scope.inputData.licenseId,
                },
            );

        }

        this.$scope.changeWizard()(stateName, params, { reload: false });

    }

}

class ChooseDeviceOsDeploymentWizardDirective {

    constructor() {

        this.template = require('./choose-os-type-deployment-wizard.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $state,
            $scope, Util,
        ) =>
            new ChooseDeviceOsDeploymentWizardController(
                $state,
                $scope, Util,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'chooseDeviceOsDeploymentWizardCtrl';

    }

}

_directiveDependencies.push(() =>
    new ChooseDeviceOsDeploymentWizardDirective());

angular.module('directives')
    .directive('chooseOsTypeDeploymentWizard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/choose-os-type-deployment-wizard/choose-os-type-deployment-wizard.js